import { Typography } from '@mui/material';

import { CollapsibleSection } from '@eng-mono/atlassian/jira/mojira-bugtracker/frontend-feature-issue-list-collapsible-section';
import { JsmIssueBase } from '@eng-mono/atlassian/jira/mojira-bugtracker/util-issue-list-fe';

interface DatesCollapseProps {
  issue: JsmIssueBase;
  expanded: boolean;
  toggleSection: () => void;
}

export function DatesCollapse({
  issue,
  expanded,
  toggleSection,
}: DatesCollapseProps) {
  return (
    <CollapsibleSection
      title="Dates"
      expanded={expanded}
      setExpanded={toggleSection}
    >
      <Typography sx={{ marginBottom: 2 }}>
        Created: {new Date(issue?.fields.created).toLocaleString()}
      </Typography>
      <Typography sx={{ marginBottom: 2 }}>
        Updated: {new Date(issue?.fields.updated).toLocaleString()}
      </Typography>
      <Typography sx={{ marginBottom: 2 }}>
        Resolved:{' '}
        {issue?.fields.resolutiondate
          ? new Date(issue?.fields.resolutiondate).toLocaleString()
          : 'Unresolved'}
      </Typography>
    </CollapsibleSection>
  );
}
